import React, { ReactNode } from "react";
import styles from "./callblockquote.module.css";
import { useCustomClassContext } from "../../../hooks/useCustomClassContext/CustomClassContext";
import cx from "classnames";
type callOnQuoteProps = {
  title?: ReactNode;
  description?: string;
  label?: string;
  quoteSvg?: string;
  quoteSvgBtm?: string;
};

const CallOnQuote: React.FC<callOnQuoteProps> = ({
  label,
  title,
  description,
  quoteSvg,
  quoteSvgBtm,
}: callOnQuoteProps): ReactNode => {
  const customClass = useCustomClassContext();
  return (
    (title || description) && (
      <div
        className={cx(
          styles.callblockContainer,
          customClass?.callBlock?.horizontalLine,
        )}
      >
        <div
          className={cx(
            styles.callblockTextContainer,
            customClass?.callBlock?.verticalLine,
          )}
        >
          {quoteSvg && (
            <div className={styles.callQuoteSvg}>
              <img src={quoteSvg} />
            </div>
          )}

          {label && <div className={styles.callQuoteLabel}>{label}</div>}

          {title && <div className={styles.callblockTitle}>{title}</div>}

          {description && (
            <div className={styles.callblockDescription}>{description}</div>
          )}

          {quoteSvgBtm && (
            <div className={styles.callQuoteSvgBtm}>
              <img src={quoteSvgBtm} />
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default CallOnQuote;
